import { trackEvent } from '@repo/common/analytics';
import type { IUser, IWorkspace } from '../../../api/types';

/**
 * Track dashboard creation event
 */
export function trackDashboardCreated(
	mode: 'manual',
	dashboardId: string,
	user?: IUser,
	workspace?: IWorkspace | null
) {
	trackEvent(
		'dashboard/created',
		{
			mode,
			dashboard_id: dashboardId,
		},
		user,
		workspace
	);
}

/**
 * Track metric creation event
 */
export function trackMetricCreated(
	mode: 'manual',
	metricId: string,
	user?: IUser,
	workspace?: IWorkspace | null
) {
	trackEvent(
		'metric/created',
		{
			mode,
			metric_id: metricId,
		},
		user,
		workspace
	);
}

/**
 * Track dashboard view event
 */
export function trackDashboardViewed(
	dashboardId: string,
	user?: IUser,
	workspace?: IWorkspace | null
) {
	trackEvent(
		'dashboard/viewed',
		{
			dashboard_id: dashboardId,
		},
		user,
		workspace
	);
}

/**
 * Track metric view event
 */
export function trackMetricViewed(
	metricId: string,
	user?: IUser,
	workspace?: IWorkspace | null
) {
	trackEvent(
		'metric/viewed',
		{
			metric_id: metricId,
		},
		user,
		workspace
	);
}

/**
 * Track metric SQL modification event
 */
export function trackMetricSqlModified(
	metricId: string,
	user?: IUser,
	workspace?: IWorkspace | null
) {
	trackEvent(
		'metric/sql_modified',
		{
			metric_id: metricId,
		},
		user,
		workspace
	);
}

/**
 * Track metric chart type change event
 */
export function trackMetricChartTypeChanged(
	metricId: string,
	chartType: string,
	user?: IUser,
	workspace?: IWorkspace | null
) {
	trackEvent(
		'metric/chart_type_changed',
		{
			metric_id: metricId,
			chart_type: chartType,
		},
		user,
		workspace
	);
}

/**
 * Track dashboard share event
 */
export function trackDashboardShared(
	dashboardId: string,
	user?: IUser,
	workspace?: IWorkspace | null
) {
	trackEvent(
		'dashboard/shared',
		{
			dashboard_id: dashboardId,
		},
		user,
		workspace
	);
}

/**
 * Track dashboard subscription event
 */
export function trackDashboardSubscribed(
	dashboardId: string,
	user?: IUser,
	workspace?: IWorkspace | null,
	destination?: 'slack'
) {
	trackEvent(
		'dashboard/subscribed',
		{
			dashboard_id: dashboardId,
			...(destination && { destination }),
		},
		user,
		workspace
	);
}
